export function useDeviceHandling() {
  const setupDeviceHandling = async () => {
    try {
      // Detect iOS devices
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
      
      if (isIOS) {
        console.log('📱 iOS device detected - layout will remain stable in landscape mode')
        document.body.classList.add('ios-device')

        // Add orientation change listener for iOS
        window.addEventListener('orientationchange', () => {
          setTimeout(() => {
            // Force a layout recalculation after orientation change
            window.scrollTo(0, 0)
            document.body.style.height = window.innerHeight + 'px'
          }, 100)
        })
      } else if ('screen' in window && 'orientation' in screen && 'lock' in screen.orientation) {
        await (screen.orientation as any).lock('portrait')
        console.log('🔒 Screen orientation locked to portrait')
      }
    } catch (error) {
      console.log('⚠️ Screen orientation handling not supported or failed:', error)
    }
  }

  return {
    setupDeviceHandling
  }
} 